import { getGraphQLClient } from 'utilities/graphql';
import {
  clearLocalStorageKey,
  getLocalStorageKey,
  setLocalStorageKey,
} from 'utilities/localStorage';

import CreateAnonRecordingCache from './CreateAnonRecordingCache.graphql';
import GetVideoInfo from './GetVideoInfo.graphql';
import UpdateAnonRecordingOwnership from './UpdateAnonRecordingOwnership.graphql';

export function slideToElement(className) {
  const element = document.querySelector(`.${className}`);

  if (!element) {
    return;
  }

  window.requestAnimationFrame(() =>
    element.scrollIntoView({ behavior: 'smooth' })
  );
}

export const getVideoOwnerId = id => {
  const gqlClient = getGraphQLClient();

  return gqlClient.query({
    query: GetVideoInfo,
    variables: { id },
  });
};

export const createAnonRecordingCache = videoArgs => {
  const gqlClient = getGraphQLClient();

  return gqlClient.mutate({
    mutation: CreateAnonRecordingCache,
    variables: {
      ...videoArgs,
    },
  });
};

export const updateAnonRecordingOwnership = () => {
  const gqlClient = getGraphQLClient();

  return gqlClient.mutate({
    mutation: UpdateAnonRecordingOwnership,
  });
};

// anon record reply
export const RECORD_REPLY_VIDEO = 'record-reply-video';

export const getRecordedReplyVideoData = () => {
  return getLocalStorageKey(RECORD_REPLY_VIDEO);
};

export const setRecordedReplyVideoData = data => {
  setLocalStorageKey(RECORD_REPLY_VIDEO, data);
};

export const removeRecordReplyData = () => {
  clearLocalStorageKey(RECORD_REPLY_VIDEO);
};
